
import {Vue, Component} from 'vue-property-decorator';
import {getPackagingProviders, updatePackaging} from "@/api/customer-package";

@Component({
  name: 'editPackage',
})
export default class extends Vue {
  private show = false;
  private bagEnable = false;
  private boxEnable = false;
  private providersOptions = [];
  private editData = {
    id: "",
    hqProductName: "",
    inquiryRefType: "",
    inquiryRefNumber: "",
    supplierAbbr: "",
    innerBag: {
      id: "",
      desc: "",
      itemsPerPack: 1,
      provider: "",
      remark: "",
      details: [],
    },
    innerBox: {
      id: "",
      desc: "",
      itemsPerPack: 1,
      provider: "",
      remark: "",
      details: [],
    },
  };

  created() {
    this.getProviders();
  }

  private async getProviders() {
    this.providersOptions = await getPackagingProviders() as any;
    this.normalizeProviderFields();
  }

  public openDialog(data: any) {
    this.editData = data;
    this.normalizeProviderFields();
    if (this.editData.innerBag.provider) {
      this.bagEnable = true;
    } else {
      this.editData.innerBag = {
        id: "",
        desc: "",
        itemsPerPack: 1,
        provider: "",
        remark: "",
        details: [],
      };
    }
    if (this.editData.innerBox.provider) {
      this.boxEnable = true;
    } else {
      this.editData.innerBox = {
        id: "",
        desc: "",
        itemsPerPack: 1,
        provider: "",
        remark: "",
        details: [],
      };
    }
    this.show = true;
  }

  private normalizeProviderValue(provider: string) {
    if (!provider) {
      return "";
    }
    const matchedProvider = this.providersOptions.find((item: any) => item.name === provider || item.desc === provider);
    return matchedProvider ? matchedProvider.name : provider;
  }

  private normalizeProviderFields() {
    if (this.editData.innerBag) {
      this.editData.innerBag.provider = this.normalizeProviderValue(this.editData.innerBag.provider);
    }
    if (this.editData.innerBox) {
      this.editData.innerBox.provider = this.normalizeProviderValue(this.editData.innerBox.provider);
    }
  }

  private addRow(type: 'bag' | 'box') {
    if (type === 'bag') {
      this.editData.innerBag.details.push({
        supplierDimension: '',
        actualDimension: '',
        name: '',
        code: '',
        specification: '',
        unitPrice: 0,
        quantity: 0,
      })
    } else {
      this.editData.innerBox.details.push({
        supplierDimension: '',
        actualDimension: '',
        name: '',
        code: '',
        specification: '',
        unitPrice: 0,
        quantity: 0,
      })
    }
  }

  private removeRow(type: 'bag' | 'box', rowIndex: number) {
    if (type === 'bag') {
      this.editData.innerBag.details.splice(rowIndex, 1);
    } else {
      this.editData.innerBox.details.splice(rowIndex, 1);
    }
  }

  private async submit() {
    const data = {
      id: this.editData.id,
      innerBag: this.bagEnable ? this.editData.innerBag : null,
      innerBox: this.boxEnable ? this.editData.innerBox : null,
    };
    await updatePackaging(data);
    this.$message({
      message: '编辑成功',
      type: 'success'
    });
    this.show = false;
    this.$emit('refresh');
  }

  private closeDialog() {
    this.bagEnable = false;
    this.boxEnable = false;
    this.show = false;
  }
}
